
/******************************************
 @name 对话框相关工具方法
 @function dialogDefaultConfig 对话框默认配置
 @function _showDialog 显示对话框[私有]
 @function _hideDialog 隐藏对话框[私有]
 @function _getData 获取对话款数据[私有]
 @function _setData 设置对话框数据[私有]
 @function dialogManage 对话框数据管理
 ******************************************/


/** @name 对话框默认配置
 *  @return {Object} 对话框默认配置
 *  - {Any} data 对话框记录数据
 *  - {Boolean} visible 对话框显示开关
 *  @author 王汝鹏
 *  @version 2019-11-10
 */
export const dialogDefaultConfig = function() {
  return {
    data: null,
    visible: false,
  }
}
/** @name 显示对话框
 *  @param {Any} data 对话框记录数据
 *  @return {void} 
 *  @author 王汝鹏
 *  @version 2019-11-10
 */
const _showDialog = function(data=null) {
  this.visible = true;
  this.data = data;
}
/** @name 隐藏对话框
 *  @param {Any} data 对话框记录数据
 *  @return {void} 
 *  @author 王汝鹏
 *  @version 2019-11-10
 */
const _hideDialog = function(data=null) {
  this.visible = false;
  this.data = data;
}
/** @name 获取对话框数据
 *  @return {Any} 对话框数据
 *  @author 王汝鹏 
 *  @version 2019-11-10
 */
const _getData = function() {
  return this.data;
}
/** @name 设置对话框数据
 *  @param {Any} data 对话框数据
 *  @author 王汝鹏 
 *  @version 2019-11-10
 */
const _setData = function(data) {
  this.data = data;
}
/** @name 对话框管理方法
 *  @param {Object} config 对话框配置
 *  @return {Object} 对框框配置相关操作方法
 *  @author 王汝鹏
 *  @version 2019-11-10
 */
export const dialogManage = function(config) {
  return {
    show: (value) => {
      _showDialog.bind(config)(value);
      return dialogManage(config);
    },
    hide: (value) => {
      _hideDialog.bind(config)(value);
      return dialogManage(config);
    },
    get data() {
      return _getData.bind(config)();
    },
    set data(value) {
      _setData.bind(config)(value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/dialog_manage.js